import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BannerHelper } from '@/components/common/BannerToast';
import InformationModal from '@/components/dashboard/knowledge-bases-create/InformationModal';
import { ChatbotEditContext } from '@/pages/dashboard/ChatbotEdit';

import DatePickerButton from '../../../common/date-picker-button';
import LoadingComponent from '../../../common/loading/loading.component';
import BrowserLanguageChart from './BrowserLanguageChart';
import ConversationChart from './ConversationChart';
import DeviceTypeChart from './DeviceTypeChart';
import FirstIntractionChart from './first-intraction-chart';
import TimeZoneChart from './TimeZoneChart';

function ChatbotCharts() {
  const { t } = useTranslation();
  const pastDate = (numberDay: number) => {
    const currentDate = new Date(); // Get the current date
    const pastDate = new Date(currentDate); // Clone the current date
    pastDate.setDate(currentDate.getDate() - numberDay);
    return pastDate;
  };

  const convertDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}-${day}`;
  };

  const chatBotEditValue = useContext(ChatbotEditContext);
  const [toDate, setToDate] = useState<string>(convertDate(new Date()));
  const [fromDate, setFromDate] = useState<string>(convertDate(pastDate(7)));

  if (chatBotEditValue?.value?.tab != 'statistics') {
    return <LoadingComponent />;
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      <div className="tw-mb-4">
        <BannerHelper
          message={t('HelpBanner/Statistic/hint')}
          buttons={
            <InformationModal
              btnTitle={t('HelpBanner/Statistic/cta')}
              modalTitle={t('HelpBanner/Statistic/title')}
              content={[
                t('HelpBanner/Statistic/content1'),
                t('HelpBanner/Statistic/content2'),
                t('HelpBanner/Statistic/content3'),
                t('HelpBanner/Statistic/content4'),
              ]}
              youtube={{
                enUrl: 'https://www.youtube.com/embed/FPcobM5Rsjg',
                frUrl: 'https://www.youtube.com/embed/FPcobM5Rsjg',
              }}
            />
          }
        />
      </div>
      <div className="tw-flex lg:tw-justify-end tw-justify-start  lg:tw-flex-row tw-flex-col tw-items-center tw-gap-3">
        <DatePickerButton
          text={t('BusinessPartner/SimulateurAffiliation/from')}
          onChangeDate={(date: string) => {
            setFromDate(date);
          }}
          value={pastDate(7)}
        />

        <DatePickerButton
          text={t('BusinessPartner/SimulateurAffiliation/to')}
          onChangeDate={(date: string) => {
            setToDate(date);
          }}
        />
      </div>

      <div className="tw-grid lg:tw-grid-cols-2 tw-grid-cols-1  tw-gap-4">
        <div className=" tw-px-6 tw-py-4 tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200 ">
          <ConversationChart botId={chatBotEditValue?.value?.botId} from={fromDate} to={toDate} />
        </div>
        <div className="tw-px-6 tw-py-4 tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200">
          <FirstIntractionChart botId={chatBotEditValue?.value?.botId} from={fromDate} to={toDate} />
        </div>
      </div>
      <div className=" tw-px-6 tw-py-4 tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200">
        <DeviceTypeChart botId={chatBotEditValue?.value?.botId} from={fromDate} to={toDate} />
      </div>
      <div className="tw-grid lg:tw-grid-cols-2 tw-grid-cols-1  tw-gap-4">
        <div className=" tw-px-6 tw-py-4 tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200">
          <TimeZoneChart botId={chatBotEditValue?.value?.botId} from={fromDate} to={toDate} />
        </div>
        <div className=" tw-px-6 tw-py-4 tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200">
          <BrowserLanguageChart botId={chatBotEditValue?.value?.botId} from={fromDate} to={toDate} />
        </div>
      </div>
    </div>
  );
}

export default ChatbotCharts;
